import React, { Component } from 'react';
import { inject, observer } from 'mobx-react/index';
import { Table } from 'antd';
import moment from 'moment-timezone';

@inject('store')
@observer
export class RecentSignalsTable extends Component {
    componentDidMount() {
        this.props.store.copyTradingStore.getRecentSignals();
    }

    render() {
        const timezone = this.props.store.userStore.currentUser.timezone;
        return (
            <div>
                <Table
                    dataSource={this.props.store.copyTradingStore.signals}
                    rowKey={'_id'}
                    columns={[
                        {
                            title: 'Side',
                            dataIndex: 'side',
                            key: 'side',
                            render(text) {
                                return text === 'buy' ? (
                                    <i className={`fal fa-arrow-up success`} />
                                ) : text === 'sell' ? (
                                    <i className={`fal fa-arrow-down error`} />
                                ) : null;
                            }
                        },
                        {
                            title: 'Exchange',
                            dataIndex: 'exchange',
                            key: 'exchange'
                        },
                        {
                            title: 'Symbol',
                            dataIndex: 'symbol',
                            key: 'symbol'
                        },
                        {
                            title: 'Entry',
                            dataIndex: 'price',
                            key: 'price'
                        },
                        {
                            title: 'Exit',
                            dataIndex: 'tp_target',
                            key: 'tp_target'
                        },
                        {
                            title: 'Stop Loss',
                            dataIndex: 'sl_target',
                            key: 'sl_target'
                        },
                        {
                            title: 'Created At',
                            dataIndex: 'created_at',
                            key: 'created_at',
                            render: (text, record) => {
                                return moment(text)
                                    .tz(timezone)
                                    .format('DD/MM/YYYY hh:mm:ss a');
                            }
                        }
                    ]}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/CopyTradingView/RecentSignalsTable.js